import { useEffect, useState } from "react";

export default function WordByWordText({ text, speed = 50, pause = 10000 }) {
  const words = text.split(" ");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let timer;

    if (index < words.length) {
      timer = setTimeout(() => {
        setIndex((prev) => prev + 1);
      }, speed);
    } else {
      timer = setTimeout(() => {
        setIndex(0);
      }, pause);
    }

    return () => clearTimeout(timer);
  }, [index, words.length, speed, pause]);

  return (
    <p className="min-h-[4.5rem] leading-relaxed text-neutral-textSecondary sm:min-h-[3.5rem]">
      {words.slice(0, index).join(" ")}
      <span className="animate-blink">.</span>
    </p>
  );
}
